import { clientApi } from 'shared/api/clientApi'
import { Response } from 'shared/models/general'

import {
  TourAdditionalPaymentRequest,
  TourAdditionalPaymentResponse,
  TourDocumentDataDto,
} from './model'

export const TourDocumentApi = {
  getDocumentData(documentId: string, signal?: AbortSignal) {
    return clientApi.get<Response<TourDocumentDataDto>>(
      `tours/document-data/${documentId}`,
      { signal },
    )
  },

  confirmDocument(documentId: string) {
    return clientApi.post<Response<TourDocumentDataDto>>(
      `tours/document-data/${documentId}/confirm`,
    )
  },

  confirmAdditionalDocument(documentId: string) {
    return clientApi.post<Response<TourDocumentDataDto>>(
      `tours/document-data/${documentId}/confirm-additional`,
    )
  },

  createAdditionalPayment(
    documentId: string,
    body: TourAdditionalPaymentRequest,
  ) {
    return clientApi.post<TourAdditionalPaymentResponse>(
      `tours/document-data/${documentId}/additional-payments`,
      body,
    )
  },
}
